import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './break_publish.component.html'
})
export class BreakPublishModalComponent extends BaseSupportModalComponent {
	title: string;
	siteId: string;
	domainUrl: string;

	async ok() {
		if (confirm(`Подтвердите отмену публикации для сайта: ${this.domainUrl}`)) {
			await this.supportService.breakPublish(this.siteId, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
